package com.wintermar.inspection.feature.domain.usecase.answer

import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.feature.domain.model.answer.AnswerFileModel
import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.feature.domain.repository.answer.AnswerChunkFileRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerFileRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerLocationRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerSelectionRepository

class UpsertAnswerUseCase(
    private val answerRepository: AnswerRepository,
    private val answerLocationRepository: AnswerLocationRepository,
    private val answerSelectionRepository: AnswerSelectionRepository,
    private val answerChunkFileRepository: AnswerChunkFileRepository,
    private val answerFileRepository: AnswerFileRepository
) {
    private suspend fun handleAnswerFiles(answerModel: AnswerModel) {
        var answerFiles: List<AnswerFileModel> = listOf()
        val resultAnswerFiles = answerFileRepository.getAnswerFiles(answerModel.id)

        if (resultAnswerFiles is Result.Success) {
            answerFiles = resultAnswerFiles.data ?: listOf()
        }

        answerFiles
            .filter { it.acceptableToDelete() }
            .forEach {
                answerFileRepository.deleteAnswerFileById(it.id)
                answerChunkFileRepository.deleteAnswerChunkFileByAnswerFileId(it.id)
            }
        val listKeepFileId = answerFiles.filter { !it.acceptableToDelete() }.map { it.id }
        val newFiles = answerModel.files.filter { !listKeepFileId.contains(it.id) }

        answerFileRepository.insertAnswerFiles(
            newFiles.map {
                it.copy(answerId = answerModel.id)
            }
        )
        answerChunkFileRepository.insertAnswerChunkFiles(
            newFiles.flatMap {
                it.chunkFiles
            })
    }

    private suspend fun handleAnswerLocation(answerModel: AnswerModel) {
        if (answerModel.answerLocation.name.isNotBlank()) {
            answerLocationRepository.insertAnswerLocation(
                answerModel.answerLocation.copy(answerId = answerModel.id)
            )
            return
        }

        answerLocationRepository.deleteAnswerLocationByAnswerId(answerModel.id)
    }

    private suspend fun handleAnswerSelection(answerModel: AnswerModel) {
        if (answerModel.answerSelection.answerSelectionId.isNotBlank()) {
            answerSelectionRepository.insertAnswerSelection(
                answerModel.answerSelection.copy(answerId = answerModel.id)
            )
            return
        }

        answerSelectionRepository.deleteAnswerSelectionByAnswerId(answerModel.id)
    }


    suspend operator fun invoke(answerModel: AnswerModel): Result<Unit> {
        handleAnswerLocation(answerModel)
        handleAnswerSelection(answerModel)
        handleAnswerFiles(answerModel)
        return answerRepository.insertAnswer(answerModel)
    }
}
